import { component as defineComponent } from 'flightjs';
import popupLink from './popupLink';

export default defineComponent(function() {
    this.after('initialize', function() {
        this.on(this.$node, 'click', this.popupLink);
    });

    this.popupLink = function(e) {
        popupLink(e);
    };
});



// WEBPACK FOOTER //
// ./src/web/js/app/ui/popup-link.js